import React, { useMemo } from 'react';
import { humanReadableFloorNumber } from '../../../../services/text/getLocationPosition';
import MultiSelectChipField from '../../MultiSelectChipField/MultiSelectChipField';
import MultiSelectChipDropDown from '../../MultiSelectChipField/MultiSelectChipDropDown';
import { localise } from '../../../../services/lang/lang';
const floors = [-1, 0, 1, 2, 3, 4, 5].map((floor) => ({
    value: floor,
    text: humanReadableFloorNumber(floor),
}));
const LocationPositionField = ({ floorNumber, onFloorUpdated, onRoomPositionsUpdated, roomPositionOptions, selectedRoomPositions, isDisabled, }) => {
    const selectedChips = useMemo(() => {
        const chips = floorNumber != null
            ? [{ value: floorNumber, text: humanReadableFloorNumber(floorNumber) }]
            : [];
        selectedRoomPositions?.forEach((dir) => {
            chips.push({ value: dir.id, text: dir.name });
        });
        return chips;
    }, [floorNumber, selectedRoomPositions]);
    const availableChips = useMemo(() => [
        {
            heading: 'Floor',
            chips: floors.map((floor) => ({
                ...floor,
                isSelected: floorNumber === floor.value,
            })),
            key: 'floor_number',
        },
        {
            heading: 'Direction',
            chips: roomPositionOptions?.map((direction) => ({
                value: direction.id,
                text: direction.name,
                isSelected: !!selectedRoomPositions.find((p) => p.id === direction.id),
            })) ?? [],
            key: 'room_positions',
        },
    ], [roomPositionOptions, selectedRoomPositions, floorNumber]);
    const onChipSelected = (category, chip) => {
        const exists = selectedChips.some((roomPosition) => roomPosition.value === chip.value && roomPosition.text === chip.text);
        if (category.key === 'floor_number') {
            if (chip.isSelected) {
                onFloorUpdated(null);
                return;
            }
            if (chip.value !== floorNumber && !exists) {
                onFloorUpdated(chip.value);
            }
            return;
        }
        if (category.key === 'room_positions') {
            if (chip.isSelected) {
                onRoomPositionsUpdated(selectedRoomPositions.filter((roomPosition) => roomPosition.id !== chip.value));
                return;
            }
            if (!exists) {
                onRoomPositionsUpdated([
                    ...selectedRoomPositions,
                    { id: chip.value, name: chip.text },
                ]);
            }
        }
    };
    return (React.createElement(MultiSelectChipField, { isDisabled: isDisabled, chips: selectedChips, label: localise('POSITION') },
        React.createElement(MultiSelectChipDropDown, { categories: availableChips, onChipSelected: onChipSelected })));
};
export default LocationPositionField;
